import { SET_IS_REQUIRED_MODULE } from '../actions/isRequiredModuleActions';

let initialState = false;

const isRequiredModuleReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_IS_REQUIRED_MODULE:
            return action.payload.value
        default:
            return state;
    }
}

export default isRequiredModuleReducer;